const DashboardRoutes = {
  getDashboardStats: "/companies/stats",
};

export default DashboardRoutes